import React, { useState } from 'react';
import './PhoneNumberPopup.css';

const PhoneNumberPopup = ({ onClose }) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!phoneNumber) return;

    setIsSubmitting(true);
    try {
      // TODO: Add API call to save phone number
      console.log('Phone number submitted:', phoneNumber);
      onClose();
    } catch (error) {
      console.error('Error submitting phone number:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="phone-popup-overlay">
      <div className="phone-popup-container">
        <button className="phone-popup-close" onClick={onClose}>×</button>
        
        <h2 className="phone-popup-title">Get a daily LUV text</h2>
        
        <p className="phone-popup-description">
          <div>LUV AI will send you a text about love every day.</div>
        </p>

        <form onSubmit={handleSubmit} className="phone-popup-form">
          <input
            type="tel"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            placeholder="Enter your phone number"
            className="phone-input"
            pattern="[0-9]{10}"
            required
          />
          
          <button 
            type="submit" 
            className="submit-button"
            disabled={isSubmitting || !phoneNumber}
          >
            {isSubmitting ? 'Sending...' : 'Text me LUV'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PhoneNumberPopup; 